import React from 'react'

import useContactForm from '../../../hooks/useContactForm'
import ContactSection from '../../sections/ContactSection'

import { ContactSliceProps } from './types'
import { socialIcons } from './consts'
import { useLiveAgent } from '../../../contexts/LiveAgent'

const ContactSlice: React.FC<ContactSliceProps> = ({ slice }) => {
  const {
    contact_title,
    contact_is_main_heading,
    contact_subtitle,
    contact_email = '',
    contact_email_icon,
    contact_chat_title = '',
    contact_chat_icon,
    contact_social_title,
    contact_form
  } = slice.primary || {}

  const form = useContactForm(contact_form?.document)
  const { openChat } = useLiveAgent()

  return (
    <ContactSection
      isHeadingGreen={true}
      inner="inners.primary"
      paddingTop={['40px', '', '84px']}
      paddingBottom={['40px', '', '40px']}
      data={{
        title: contact_title?.text,
        isMainHeading: contact_is_main_heading,
        subtitle: contact_subtitle?.text,
        mail: {
          title: contact_email,
          url: contact_email,
          icon: {
            dimensions: contact_email_icon?.dimensions,
            alt: contact_email_icon?.alt,
            url: contact_email_icon?.url
          }
        },
        chat: {
          title: contact_chat_title,
          icon: {
            dimensions: contact_chat_icon?.dimensions,
            alt: contact_chat_icon?.alt,
            url: contact_chat_icon?.url
          },
          onClick: openChat
        },
        social: {
          title: contact_social_title?.text,
          list: slice.items?.map((social, index) => ({
            key: index,
            label: social?.contact_social_icon,
            icon: social?.contact_social_icon && socialIcons[social?.contact_social_icon],
            url: social?.contact_social_link?.url || '#'
          }))
        },
        form
      }}
    />
  )
}

export default ContactSlice
